import { FC } from 'react';
import { HeaderWaffleMenuProps } from './types';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
import { CatIconLayoutModule } from '@blocks-react/components/Icons/LayoutModule';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

export const HeaderWaffleMenu: FC<HeaderWaffleMenuProps> = ({
  displayMobileNavLink,
  handleDrawerProps,
  id,
  isCurrent,
  text,
  title
}) => {
  const headerNavItemsProps = {
    ...handleDrawerProps,
    isCurrent
  };
  return displayMobileNavLink ? (
    <CatPrimaryNavItem
      data-testId="cat-header-waffle-icon"
      id={id}
      isCurrent={isCurrent}
      text={text}
      title={title}
      {...handleDrawerProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.WAFFLE_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      style={{
        borderBottom: '1px solid var(--cat-theme-color-border-strong-hover)'
      }}
      role="menu"
    >
      <CatIconLayoutModule iconTitle={text} slot="before" />
    </CatPrimaryNavItem>
  ) : (
    <HeaderNavItem
      aria-label={text}
      data-testId="cat-header-waffle-icon"
      id={id}
      title={title}
      {...headerNavItemsProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.WAFFLE_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      role="menu"
    >
      <CatIconLayoutModule iconTitle={text} />
    </HeaderNavItem>
  );
};
